import { z } from 'zod';

export const locationSchema = z.object({
  idLocation: z.number().default(-1),
  Location: z.string().default(''),
  idFederalState: z.number().default(0),
  FederalState: z.string().default(''),
  idPostcode: z.number().nullable().default(null),
  Postcode: z.string().default(''),
  City: z.string().default(''),
  Street: z.string().default(''),
  StreetNr: z.string().default(''),
  StreetAdditional: z
    .string()
    .nullable()
    .transform(value => value ?? '')
    .default(''),
  Comment: z
    .string()
    .nullable()
    .transform(value => value ?? '')
    .default(''),
  isDefault: z
    .union([z.boolean(), z.number(), z.null()])
    .transform(value => Boolean(value))
    .default(false),
});

export type ILocation = z.infer<typeof locationSchema>;
